<template>
  <circle opacity="0.1" cx="27.5" cy="27.5001" r="27.5" fill="#4794F7" />
  <circle cx="27" cy="22.9999" r="5" fill="#3769D6" />
  <path
    opacity="0.5"
    d="M19 36.9999C19 33.1339 22.134 29.9999 26 29.9999H27C30.866 29.9999 34 33.1339 34 36.9999C34 37.5522 33.5523 37.9999 33 37.9999H20C19.4477 37.9999 19 37.5522 19 36.9999Z"
    fill="#3769D6"
  />
</template>
